"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var react_1 = __importDefault(require("react"));

var typings_1 = require("../../typings");

var form_base_1 = require("./form-base");

var Input = function Input(_a) {
  var id = _a.id,
      name = _a.name,
      type = _a.type,
      value = _a.value,
      error = _a.error,
      label = _a.label,
      legend = _a.legend,
      theme = _a.theme,
      placeholderText = _a.placeholderText,
      onInputChanged = _a.onInputChanged,
      _b = _a.orientation,
      orientation = _b === void 0 ? typings_1.Orientation.left : _b;
  var style = "block appearance-none w-full " + (theme ? theme.form.backgroundColor : 'bg-white') + " rounded border " + (theme ? theme.form.borderColor : 'border-gray-400') + " hover:" + (theme ? theme.form.borderHoverColor : 'border-gray-500') + " shadow focus:outline-none focus:shadow-outline p-2 transition duration-150 ease-in-out " + (orientation === typings_1.Orientation.right ? 'text-right' : 'text-left') + " sm:text-sm sm:leading-5 " + (theme ? theme.form.placeholderColor : 'placeholder-gray-800');
  return react_1["default"].createElement(form_base_1.FormBase, {
    label: label,
    htmlFor: id,
    legend: legend,
    theme: theme,
    error: error,
    orientation: orientation
  }, react_1["default"].createElement("div", {
    className: "w-full mt-1 mb-1 rounded-md shadow-sm"
  }, react_1["default"].createElement("input", {
    id: id,
    name: name,
    type: type,
    value: value,
    onChange: function onChange(_a) {
      var value = _a.target.value;
      return onInputChanged(value);
    },
    className: style,
    placeholder: placeholderText
  })));
};

exports.Input = Input;